import React, { useEffect, useState } from 'react';
import { useI18n } from '../../i18n/LanguageContext';
import { useCookieConsent } from '../../site/CookieConsent';
import { PublicLocation } from '../../types';
import { PublicApi } from '../../utils/apiClient';
import { fallbackLocations } from '../../data/fallback';
import FadeIn from './FadeIn';

const CONSENT_TEXT: Record<string, { msg: string; btn: string }> = {
  de: { msg: 'Karte durch Google Maps – bitte Cookies akzeptieren, um sie zu laden.', btn: 'Karten aktivieren' },
  en: { msg: 'Map provided by Google Maps – please accept cookies to load it.', btn: 'Enable maps' },
  it: { msg: 'Mappa fornita da Google Maps – accetta i cookie per caricarla.', btn: 'Abilita le mappe' },
};

const Locations: React.FC = () => {
  const { t, lang } = useI18n();
  const { hasConsent, prefs, savePrefs } = useCookieConsent();
  const ct = CONSENT_TEXT[lang] || CONSENT_TEXT.de;
  const enableMaps = () => savePrefs({ ...prefs, maps: true });
  const [items, setItems] = useState<PublicLocation[]>(() => fallbackLocations(lang));

  useEffect(() => {
    let cancelled = false;
    setItems(fallbackLocations(lang));
    PublicApi.locations(lang)
      .then((d) => { if (!cancelled && d && d.length) setItems(d); })
      .catch(() => { if (!cancelled) setItems(fallbackLocations(lang)); });
    return () => { cancelled = true; };
  }, [lang]);

  return (
    <section id="locations">
      <div className="container">
        <FadeIn style={{ marginBottom: '2.5rem' }}>
          <span className="slabel sl-b">{t('loc.badge')}</span>
          <h2 className="stitle">{t('loc.title')}</h2>
          <p className="ssub">{t('loc.sub')}</p>
        </FadeIn>
        <div className="loc-grid">
          {items.map((l, i) => (
            <FadeIn className="loc-card" style={{ transitionDelay: `${i * 0.08}s` }} key={l.id}>
              {l.mapUrl && hasConsent('maps') ? (
                <iframe title={l.title} loading="lazy" src={l.mapUrl} />
              ) : l.mapUrl ? (
                <div className="loc-map-consent">
                  <span>{ct.msg}</span>
                  <button type="button" className="cookie-btn primary" onClick={enableMaps}>{ct.btn}</button>
                </div>
              ) : null}
              <div className="loc-body">
                <h3>{l.title}</h3>
                {l.address && <p dangerouslySetInnerHTML={{ __html: l.address }} />}
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations;
